import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Alert, Spin } from "antd";

import { ProjectHeader } from "./ProjectHeader";
import { ProjectCharts } from "./ProjectCharts";
import { useProject } from "../../hooks/useProject";

const ProjectPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const {
    project,
    loadingProject,
    fetchProjectError,
    fromDate,
    toDate,
    selectedChart,
    handleChartChange,
  } = useProject(id);

  if (!id) {
    return (
      <div className="px-12 py-8 bg-gray-50">
        <Alert type="error" showIcon message="Invalid project ID." />
      </div>
    );
  }

  if (loadingProject) {
    return (
      <div className="w-full h-full flex items-center justify-center py-16 bg-gray-50">
        <Spin size="large" />
      </div>
    );
  }

  if (fetchProjectError) {
    return (
      <div className="px-12 py-8 bg-gray-50">
        <Alert
          type="error"
          showIcon
          message="Project could not be loaded."
          description={fetchProjectError}
        />
      </div>
    );
  }

  if (!project) {
    return (
      <div className="p-6">
        <Alert type="warning" showIcon message="Project not found." />
      </div>
    );
  }

  return (
    <div className="w-full h-full flex px-12 py-8 bg-gray-50">
      <div className="w-full flex flex-col">
        {/* Header */}
        <div className="mb-6">
          <ProjectHeader
            project={project}
            fromDate={fromDate}
            toDate={toDate}
            selectedChart={selectedChart}
            onChartChange={handleChartChange}
            onBack={() => navigate("/projects")}
          />
        </div>

        {/* Charts Card */}
        <div className="rounded-xl shadow-md p-6 bg-white text-gray-800">
          <ProjectCharts
            projectId={project.id}
            fromDate={fromDate}
            toDate={toDate}
            selectedChart={selectedChart}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectPage;
